/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ServiceSparkModel } from '../../models/service-spark-model';

export interface GetPatientServices$Params {
  patientID?: number;
}

export function GetPatientServices(http: HttpClient, rootUrl: string, params?: GetPatientServices$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ServiceSparkModel>>> {
  const rb = new RequestBuilder(rootUrl, GetPatientServices.PATH, 'get');
  if (params) {
    rb.query('patientID', params.patientID, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ServiceSparkModel>>;
    })
  );
}

GetPatientServices.PATH = '/api/Staff/GetPatientServices';
